import { Rating } from '../rating/rating';
import { Tag } from '../tag/tag';
import { Button } from '../button/button';
import { ReactComponent as ArrowRight } from '../../../assets/arrow-right.svg';
import './organization-compare.css';
import { convertToTitleCase } from '../../../utils/text';
import { currencyFormatter, ratioFormatter } from '../../../utils/numbers';
import { useOrganizations, useOrganizationsDispatch } from '../../../contexts/organization-context';
import * as cn from 'classnames';
import { useNavigation } from '../../../contexts/navigation-context';
import saltExchangeLogo from '../../../assets/loading.png';

export const OrganizationCompare = ({ organization, activities }) => {
  const dispatch = useOrganizationsDispatch();
  const { to } = useNavigation();

  const handleDetailsClick = () => {
    dispatch({ type: 'organization-selected', organizationId: organization.EIN });
    to({ pageId: 'organization-detail', params: { organizationId: organization.EIN } });
  };

  const fd = organization.financials?.[0] || {};

  const activity = activities?.find((a) => a.ID === organization.ACTIVITY_ID);
  return (
    <div className={cn(['organization-compare-container'])}>
      <div className="name-container text-xlarge text-white">{convertToTitleCase(organization.NAME)}</div>
      <div className="column-container">
        <div className="column">
          <div className="title">Charity Navigator</div>
          <div className="rating-container">
            <Rating rating={organization.CHARITY_NAVIGATOR_RATING} />
          </div>
        </div>
        <div className="column">
          <div>
            <div className="title">Pre-screened</div>
            <img className={cn('is-screened-image', !organization.IS_SCREENED && 'not-screened')} src={saltExchangeLogo} alt="Is Screened" />
          </div>
        </div>
      </div>
      <div className="item">
        <div className="title">Activities</div>
        <div className="tags-container">
          {!activity && <div className="text-normal text-gray-2 text-regular"> No associated activities</div>}
          {activity && <Tag tag={activity}></Tag>}
          {organization.ACTIVITY_COUNT > 1 && <Tag tag={{ NAME: '+' + organization.ACTIVITY_COUNT - 1 }}></Tag>}
        </div>
      </div>
      <div className="item">
        <div className="title">Year founded</div>
        <div className="value">{organization.YEAR_FOUNDED || <div className="text-regular text-gray-2 text-normal">Unknown</div>}</div>
      </div>
      <div className="section-title">Financial data ({fd.TAX_YEAR || '--'})</div>
      <div className="item">
        <div className="title">Total Revenue</div>
        <div className="value">{!fd.REVENUE ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : currencyFormatter.format(fd.REVENUE)}</div>
      </div>
      <div className="item">
        <div className="title">Total Expenses</div>
        <div className="value">
          {!fd.EXPENSES ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : currencyFormatter.format(fd.EXPENSES)}
        </div>
      </div>
      <div className="item">
        <div className="title">Total Assets</div>
        <div className="value">{!fd.ASSETS ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : currencyFormatter.format(fd.ASSETS)}</div>
      </div>
      <div className="item">
        <div className="title">Total Program Revenue</div>
        <div className="value">
          {!fd.PROGRAM_REVENUE ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : currencyFormatter.format(fd.PROGRAM_REVENUE)}
        </div>
      </div>
      <div className="item">
        <div className="title">Total Contributions</div>
        <div className="value">
          {!fd.CONTRIBUTIONS ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : currencyFormatter.format(fd.CONTRIBUTIONS)}
        </div>
      </div>
      <div className="item">
        <div className="title">Revenue less expenses</div>
        <div className="value">
          {!fd.REVENUE_LESS_EXPENSES ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : currencyFormatter.format(fd.REVENUE_LESS_EXPENSES)}
        </div>
      </div>
      <div className="item">
        <div className="title">Expense Ratio</div>
        <div className="value">
          {!fd.EXPENSE_RATIO ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : ratioFormatter.format(fd.EXPENSE_RATIO)}
        </div>
      </div>
      <div className="item">
        <div className="title">Working Capital Ratio</div>
        <div className="value">
          {!fd.WORKING_CAPITAL_RATIO ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : ratioFormatter.format(fd.WORKING_CAPITAL_RATIO)}
        </div>
      </div>
      <div className="item">
        <div className="title">Months of Burnable Assets</div>
        <div className="value">
          {!fd.MONTHS_OF_BURNABLE_ASSETS ? (
            <div className="text-regular text-gray-2 text-normal">Unknown</div>
          ) : (
            ratioFormatter.format(fd.MONTHS_OF_BURNABLE_ASSETS)
          )}
        </div>
      </div>
      <div className="item">
        <div className="title">Officer Comp to Assets</div>
        <div className="value">
          {!fd.OFFICER_COMP_TO_ASSETS ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : ratioFormatter.format(fd.OFFICER_COMP_TO_ASSETS)}
        </div>
      </div>

      <div className="buttons-container">
        <Button icon={<ArrowRight />} size="large" onClick={(e) => handleDetailsClick(e)} textAlign="center">
          View more
        </Button>
      </div>
    </div>
  );
};
